import React from 'react';
import { CSSTransition } from 'react-transition-group';
import SimpleLayer from '../SimpleLayer';
import BookingContent from '../../../modals/Booking';
import CancelBookingContent from '../../../modals/CancelBooking';
import { useSecondaryModalStore } from '../../../../stores';

const SecondaryModal: React.FC = () => {
  const { isOpen, content, modalProps, message, messageType, show, hide, addMessage, clearMessage } =
    useSecondaryModalStore();

  const showModal = (passedContent: string, passedProps: Record<string, unknown> = {}) => {
    show(passedContent, passedProps);
  };

  const hideModal = () => {
    hide();
  };

  const addModalMessage = (passedMessage: string, opts: { type?: 'info' | 'error' | 'success' | 'warning'; autoDisappear?: boolean } = {}) => {
    addMessage(passedMessage, opts);
  };

  const clearModalMessage = () => {
    clearMessage();
  };

  const transitModal = (nextContent, passedProps = {}) => {
    hideModalPromise().then(() => {
      showModal(nextContent, passedProps);
    });
  };

  const hideModalPromise = () => {
    return new Promise<void>((resolve) => {
      hideModal();
      window.setTimeout(() => {
        resolve();
      }, 300);
    });
  };

  let modalContent;
  const baseModalProps = {
    addModalMessage: addModalMessage,
    clearModalMessage: clearModalMessage,
    hideModal: hideModal,
    transitModal: transitModal,
    message,
    messageType,
  };
  // Combine base modal props with dynamic modalProps from store
  // Type assertion needed as modalProps contains dynamic content-specific props
  const combinedModalProps = { ...baseModalProps, ...modalProps } as any;
  switch (content) {
    case 'booking':
      modalContent = <BookingContent {...combinedModalProps} />;
      break;
    case 'cancelBooking':
      modalContent = <CancelBookingContent {...combinedModalProps} />;
      break;
    default:
      modalContent = <div />;
      break;
  }
  const simpleLayer = !modalProps.outerClickDisabled ? (
    <SimpleLayer onClick={hideModal} />
  ) : null;
  if (isOpen) {
    return (
      <CSSTransition appear={true} timeout={500}>
        <div className="fixed inset-0 z-40 overflow-y-auto bg-black/75 sm:bg-transparent">
          <div className="table h-full w-full table-fixed sm:table">
            <div className="table-cell h-full w-full align-middle p-0 sm:table-cell sm:p-[50px]">
              {simpleLayer}
              {modalContent}
            </div>
          </div>
        </div>
      </CSSTransition>
    );
  } else {
    return (
      <CSSTransition appear={true} timeout={500}>
        <div />
      </CSSTransition>
    );
  }
};

export default SecondaryModal;
